module.exports = __webpack_public_path__ + "img/36_49.2cb312fb.png";